var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-message"},[_c('div',{staticClass:"chat-baloon"},[_c('span',{staticClass:"chat-item-text-message"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.textMessage)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }